import { initializeApp, getApps } from 'firebase/app'

const firebaseConfigMap = new Map([
  ['kingnetcare', Object.freeze({
    apiKey: 'AIzaSyBFpc6MJsvPG76ruHst31bTw1kH8fAQx1c',
    authDomain: 'kingnetcare.firebaseapp.com',
    databaseURL: 'https://kingnetcare.firebaseio.com',
    projectId: 'kingnetcare',
    storageBucket: 'smartdaily-file',
    messagingSenderId: '865338099412',
    appId: '1:865338099412:web:1b0fc30cb1b695495edd41',
    measurementId: 'G-5QLP4J7VX6'
  })],
  ['smartlife-3d231', Object.freeze({
    apiKey: 'AIzaSyDnx0MCawc9_F_FdNnqq-DRexAkUrO2FL8',
    authDomain: 'smartlife-3d231.firebaseapp.com',
    databaseURL: 'https://smartlife-3d231.firebaseio.com',
    projectId: 'smartlife-3d231',
    storageBucket: 'smartlife-3d231.appspot.com',
    messagingSenderId: '985332900753',
    appId: '1:985332900753:web:9fef872d8f32f66778f030',
    measurementId: 'G-W37YL790RN'
  })]
])

/**
 * 初始化 Firebase 應用程式
 */
function getFirebaseApp (projectId) {
  // 檢查是否已經初始化
  const existingApp = getApps().find(app => app.name === projectId)
  if (existingApp) {
    return existingApp
  } else {
    const firebaseConfig = firebaseConfigMap.get(projectId)
    return initializeApp(firebaseConfig, projectId)
  }
}

export {
  getFirebaseApp
}
